module.exports = __webpack_public_path__ + "static/media/mail.825a30f5.svg";